<mat-toolbar class="fade-in" color="primary">
    <div fxFlex="auto" class="logoBrand">
        <div (click)="goToHome()" class="clickableLogo">
            <app-logo></app-logo>
        </div>
        @if (resellerId !== 1) {
            <div class="navbar businessName fade-in" fxLayout="column">
                <div fxFlex>
                    <div (click)="goToHome()" class="clickableLogo logo logoWrap">
                        <span class="logo di clickableLogo">
                            @if (largeLogo === '1') {
                                <span>{{ businessName }}</span>
                            }
                        </span>
                    </div>
                </div>
            </div>
        }
        @if (resellerId === 1) {
            <div class="navbar fade-in" fxLayout="column">
                <div fxFlex>
                    @if (largeLogo === '1') {
                        <div (click)="goToHome()" class="clickableLogo logo logoWrap">
                            <span class="logo di clickableLogo">Digital</span>
                            <span (click)="goToHome()" class="si clickableLogo">Signage</span>
                            <span (click)="goToHome()" class="logo co clickableLogo">.com</span>
                        </div>
                    }
                </div>
                @if (largeLogo === '1') {
                    <div fxFlex>
                        <span (click)="goToHome()"
                              class="fontFree clickableLogo">FREE Digital Signage for everyone</span>
                    </div>
                }
            </div>
        }
    </div>
    @if (showMenu) {
        <div fxFlex="auto" style="position: relative; height: 100%">
            <app-nav-drop-menu></app-nav-drop-menu>
        </div>
    }


    <div fxFlex style="margin-left: 80px" cdkMenuBar class="hide-lt-md">

        @if (showExperienceLevel === '1' && (signStudioExperienceLevel$ | async) == '1') {
            <mat-icon
                style="position: relative; left: -10px; width: 27px; cursor: pointer;"
                (click)="openExperienceSelect()">
                {{ experienceLevel | experienceIcon }}
            </mat-icon>
            <mat-select #expSelect
                        [(ngModel)]="experienceLevel"
                        (selectionChange)="onExperienceLevelChange($event)"
                        [panelClass]="'dynamic-panel'"
                        class="expSelect">
                <mat-option *ngFor="let option of skillOptions" [value]="option.value">
                    <mat-icon class="exp-option-icon">{{ option.value | experienceIcon }}</mat-icon>
                    <span class="colorDropLevel">{{ option.label | transloco }}</span>
                </mat-option>
            </mat-select>
        }


        <!-- Alon remove
                @if (dashboardMode || (signStudioHelp$ | async) == '1') {
                    <button mat-button cdkMenuItem class="mat-reverse-button" [cdkMenuTriggerFor]="menuUserManagement" style="margin-left: 40px; margin-top: 18px">
                        <span style="font-size: 15px">
                               {{ 'navigation.learnVideos' | transloco }}
                        </span>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>
                }
        -->
        <!--        @if (dashboardMode || (navEnterprise$ | async) == '1') {-->
        <!--            <button mat-button cdkMenuItem class="mat-reverse-button" [cdkMenuTriggerFor]="menuEnterprise">-->
        <!--                <span style="font-size: 15px">Enterprise</span>-->
        <!--                <mat-icon>keyboard_arrow_down</mat-icon>-->
        <!--            </button>    -->
        <!--        }-->

        <ng-template #menuEnterprise>
            <div class="header-menu" cdkMenu>
                @if (upgradable) {
                    <button color="warn" mat-raised-button (click)="upgrade()" class="upgrade-button">
                        <mat-icon>rocket_launch</mat-icon>
                        {{ 'general.upgradeToEnterprise' | transloco }}
                    </button>
                }

                <a class="header-menu-item" cdkMenuItem routerLink="/enterprise/users" routerLinkActive="active"
                   (click)="onRouterClick()">
                    <mat-icon>supervisor_account</mat-icon>
                    <span class="nav-label">{{ 'navigation.users' | transloco }}</span>
                </a>
                <a class="header-menu-item" cdkMenuItem routerLink="/enterprise/privileges" routerLinkActive="active"
                   (click)="onRouterClick()">
                    <mat-icon>check</mat-icon>
                    <span class="nav-label">{{ 'navigation.privileges2' | transloco }}</span>
                </a>
                <a class="header-menu-item" cdkMenuItem routerLink="/enterprise/apps" routerLinkActive="active"
                   (click)="onRouterClick()">
                    <mat-icon>featured_video</mat-icon>
                    <span class="nav-label">{{ 'navigation.apps' | transloco }}</span>
                </a>
                <a class="header-menu-item" cdkMenuItem routerLink="/enterprise/whitelabel" routerLinkActive="active"
                   (click)="onRouterClick()">
                    <mat-icon>group_work</mat-icon>
                    <span class="nav-label">{{ 'navigation.whiteLabel' | transloco }}</span>
                </a>
                <a class="header-menu-item" cdkMenuItem routerLink="/adnet/manager" routerLinkActive="active"
                   (click)="onRouterClick()">
                    <mat-icon>card_travel</mat-icon>
                    <span class="nav-label">{{ 'navigation.adnet' | transloco }}</span>
                </a>
            </div>
        </ng-template>

        <ng-template #menuUserManagement>
            <div class="header-menu" cdkMenu>
                <!--                @if (upgradable) {-->
                <!--                    <a class="header-menu-item" cdkMenuItem spinning-->
                <!--                        routerLink="/prices" routerLinkActive="active" (click)="onRouterClick()">-->
                <!--                        <mat-icon color="warn" class="spinning">rocket_launch</mat-icon>-->
                <!--                        <span color="warn" class="nav-label">{{ 'navigation.prices' | transloco }}</span>-->
                <!--                    </a>-->
                <!--                }-->
                <a class="header-menu-item" cdkMenuItem
                   routerLink="/help/signquick" routerLinkActive="active">
                    <mat-icon style="width: 26px">tips_and_updates</mat-icon>
                    <span class="nav-label">quick introduction</span>
                </a>
                <a class="header-menu-item" cdkMenuItem
                   routerLink="/help/signfullintro" routerLinkActive="active">
                    <mat-icon>school</mat-icon>
                    <span class="nav-label">full introduction</span>
                </a>
                <a class="header-menu-item" cdkMenuItem
                   routerLink="/help/PlaylistScenes" routerLinkActive="active">
                    <mat-icon>playlist_play</mat-icon>
                    <span class="nav-label">playlist and timeline</span>
                </a>
                <a class="header-menu-item" cdkMenuItem
                   routerLink="/help/scene_all_basics" routerLinkActive="active">
                    <mat-icon class="spinning">control_camera</mat-icon>
                    <span class="nav-label">working with scenes</span>
                </a>
                <a class="header-menu-item" cdkMenuItem routerLink="/help/Scheduler" routerLinkActive="active">
                    <mat-icon class="spinning">calendar_month</mat-icon>
                    <span class="nav-label">setup a scheduler</span>
                </a>
            </div>
        </ng-template>
    </div>
    <ng-content></ng-content>
</mat-toolbar>
